<template>
  <div class="report-box zoom-in">
    <div class="box p-5">
      <div class="flex">
        <component
          :is="icon"
          v-if="icon"
          :class="['report-box__icon', iconClass ? iconClass : 'text-theme-12']"
        />
        <!-- <div class="ml-auto">
          <Tippy
            tag="div"
            :class="[
              'report-box__indicator cursor-pointer',
              percent > 0 ? 'bg-theme-9' : 'bg-theme-6',
            ]"
            :content="tooltipContent"
          >
            {{ percent }}%
            <component :is="percent >= 0 ? 'ChevronUpIcon' : 'ChevronDownIcon'" class="w-4 h-4" />
          </Tippy>
        </div> -->
      </div>
      <div class="text-3xl font-bold leading-8 mt-6">
        {{ total }}
      </div>
      <div class="text-base text-gray-600 mt-1 truncate">{{ title }}</div>
    </div>
  </div>
</template>

<script>
// import Tippy from '@/components/ui/Tippy';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {
          total: 0,
          previous: 0,
        };
      },
    },
    title: {
      type: String,
      default: 'Items',
    },
    icon: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
    },
    isCurrency: {
      type: Boolean,
      default: false,
    },
  },

  // components: {
  //   Tippy,
  // },

  computed: {
    total() {
      if (this.item.total) {
        if (this.isCurrency) {
          return this.$options.filters.currencyWithoutDecimal(this.item.total);
        }
        return this.item.total;
      }
      return 0;
    },
    percent() {
      if (this.item.previous) {
        const increase = this.item.total - this.item.previous;
        const increasePercent = (increase / this.item.previous) * 100;
        return parseInt(increasePercent, 10);
      }
      return 0;
    },
    tooltipContent() {
      return this.percent >= 0
        ? this.$t('dashboard.increaseThanLastMonth', { percent: this.percent })
        : this.$t('dashboard.decreaseThanLastMonth', { percent: this.percent });
    },
  },
};
</script>
